<h3 class="title-divider-suche">{{ heading | translate }}</h3>
<fieldset>
  <cap-form-row column-classes="col-md-1,col-md-3">
    <cap-form-control invalidKey="EingabeGrundbuchamtErforderlich" labelKey="Belegamt">
      <cap-gb-amt
        (ngModelChange)="model && (model.belegamtId = $event)"
        [ngModel]="model && model.belegamtId"
        [searchMode]="searchMode"
        name="beleg.belegamtId"></cap-gb-amt>
      <button (click)="emptyBelegSearch()" class="btn btn-white" tabindex="-1" type="button">
        <span class="fas fa-times"></span>
      </button>
    </cap-form-control>
  </cap-form-row>

  <cap-form-row column-classes="col-md-1,col-md-1">
    <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="Jahr">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.jahr = $event)"
        [ngModel]="model && model.jahr"
        #belegjahr
        name="beleg.jahr"
        size="10"
        type="text" />
    </cap-form-control>
    <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.nummer = $event)"
        [ngModel]="model && model.nummer"
        name="beleg.nummer"
        size="10"
        type="text" />
    </cap-form-control>
    <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Index">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.index = $event)"
        [ngModel]="model && model.index"
        name="beleg.index"
        size="10"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-form-row column-classes="col-md-1,col-md-3">
    <cap-form-control labelKey="BelegAlt">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.alt = $event)"
        [ngModel]="model && model.alt"
        name="beleg.alt"
        size="21"
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <cap-form-row column-classes="col-md-2,col-md-1">
    <cap-form-control invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="Belegdatum">
      <input
        (blur)="onTouched()"
        (ngModelChange)="model && (model.datum = $event)"
        [ngModel]="model && model.datum"
        name="beleg.datum"
        type="text" />
    </cap-form-control>
  </cap-form-row>
</fieldset>
